module.exports = __webpack_public_path__ + "img/right-arrow.4facce0f.svg";